module.exports = __webpack_public_path__ + "img/6.41745f93.jpg";